module.exports = __webpack_public_path__ + "media/images/consumer/account/upcoming-menus/mobile-promo/device@2x-9ee73e47705b14e964896f73ae79420c.png";